var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,{tag:"component",staticClass:"nav-item",class:{
    active:
      _vm.currentPageIs('/') ||
      _vm.currentPageIs('/patienten') ||
      _vm.currentPageIs('/rezept-express'),
  }},[_c('a',{attrs:{"href":_vm.href}},[_c('i',{attrs:{"aria-label":"Home-Symbol"}},[_c('HomeIcon')],1),_c('span',[_vm._v("Startseite")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }